module.exports = __webpack_public_path__ + "static/livechat3-3fd5541ca90bc9f1a704ce82c48846a4.png";